import { createStyles } from '@mantine/styles';

var useStyles = createStyles((theme) => ({
  input: {
    paddingTop: theme.spacing.xs,
    paddingBottom: theme.spacing.xs
  }
}));

export default useStyles;
//# sourceMappingURL=Textarea.styles.js.map
